
// import React from 'react';
// import { Box } from '@mui/material';

// import Sidebar from '../../../Seller/Sidebar';
// import ProfileInbox from '../../../Commonlibs/ProfileInbox';

// const ProfilePropViewed = () => {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         width: '100%',
//         minHeight: '100vh',
//         overflowX: 'hidden',
//         background: '#f9fafb',
//         flexDirection: { xs: 'column', md: 'row' },
//         gap: { xs: '10px', md: 0 }, 
//         mt: { xs: '64px', md: '15px' }, 
//       }}
//     >
//       <Box
//         sx={{
//           flexShrink: 0,
//           width: { xs: '100%', md: 'auto' },
//         }}
//       >
//       <Sidebar/>
//       </Box>

//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           gap: { xs: '10px', md: '20px' },
//           margin: { xs: '10px', md: '20px' },
//           marginTop: { xs: 0, md: '25px' }, 
//           boxSizing: 'border-box',
//           overflowX: 'auto',
//         }}
//       >
//         <ProfileInbox />
//       </Box>
//     </Box>
//   );
// };

// export default ProfilePropViewed;


import React from 'react';
import { Box } from '@mui/material';

import Sidebar from '../../../Seller/Sidebar';
import ProfileInbox from '../../../Commonlibs/ProfileInbox';

const ProfilePropViewed = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        background: '#f9fafb',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '10px', md: 0 }, 
        mt: { xs: '64px', md: '15px' }, 
      }}
    >
      {/* ✅ HIDE SIDEBAR ON MOBILE */}
      <Box
        sx={{
          flexShrink: 0,
          width: { xs: '100%', md: 'auto' },
          display: { xs: 'none', md: 'block' }, // ✅ Added this line
        }}
      >
        <Sidebar/>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: '10px', md: '20px' },
          margin: { xs: '10px', md: '20px' },
          marginTop: { xs: 0, md: '25px' }, 
          boxSizing: 'border-box',
          overflowX: 'auto',
        }}
      >
        <ProfileInbox />
      </Box>
    </Box>
  );
};

export default ProfilePropViewed;
